import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldTextarea } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const HtmlFieldToBlock: FieldToBlock<
  'html',
  WorkflowStepFormFieldTextarea
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'textarea',
  componentProps: {
    size: 'sm',
  },
});

type HtmlFieldValueProps = FieldValueProps<'html'>;

export const HtmlFieldValue: FC<HtmlFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
